import { render, staticRenderFns } from "./certificateDetail.vue?vue&type=template&id=c14ec0a4&scoped=true"
import script from "./certificateDetail.vue?vue&type=script&lang=js"
export * from "./certificateDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/user/certificateDetail.css?vue&type=style&index=0&id=c14ec0a4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c14ec0a4",
  null
  
)

export default component.exports